import { Component, inject, signal } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger, MatMenuItem } from '@angular/material/menu';
import { Router } from '@angular/router';

import { environment } from '../../../../environments/environment';
import { UserGuideComponent } from '../../../shared/components/user-guide/user-guide.component';
import { ROUTES } from '../../../shared/constants/routes';

@Component({
  selector: 'app-manage-menu',
  templateUrl: './manage-menu.component.html',
  styleUrls: ['./manage-menu.component.scss'],
  imports: [MatIcon, MatMenuTrigger, MatButtonToggleModule, MatMenu, MatMenuItem, MatDivider, UserGuideComponent],
})
export class ManageMenuComponent {
  private readonly router = inject(Router);

  protected readonly settingsMenuOpen = signal(false);
  protected readonly helpMenuOpen = signal(false);

  requestControlChange = environment.requestControlChange;
  environmentVariables = environment;

  goOutsideApp(url: string): void {
    window.open(url, '_blank');
  }

  newCase(): void {
    this.router.navigate([`${ROUTES.wizard.root}/${ROUTES.wizard.selection}`]);
  }

  onFaqLinkClick(): void {
    window.open(environment.faqUrl, '_blank');
  }

  onSettingsMenuClosed(): void {
    this.settingsMenuOpen.set(false);
  }

  onHelpMenuClosed(): void {
    this.helpMenuOpen.set(false);
  }
}
